<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <a-row :gutter="24">
          <div>
            <a-col :span="12">
              <a-form-model-item :label="$t('选择施工公司')" prop="companyId">
                <!-- <a-input v-model="model.companyId" placeholder="请输入合同编号"></a-input> -->
                <a-select v-model="model.companyId">
                   <a-select-option :value="item.id" v-for="item in companyList">
                          {{item.constructionName}}
                    </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('是否需要验收')" prop="isAcceptance">
                <a-radio-group v-model="model.isAcceptance">
                  <a-radio :value="1">{{ $t('是') }}</a-radio>
                  <a-radio :value="0">{{ $t('否') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('项目说明')" prop="projectDetail">
                <a-textarea v-model="model.projectDetail" :placeholder="$t('请输入项目说明')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </div>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'ConstructionDetailForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        url: {
          add: "/jeecg-engineering/engineering/constructionDetail/add",
          edit: "/jeecg-engineering/engineering/constructionDetail/edit",
          queryById: "/jeecg-engineering/engineering/constructionDetail/queryById",
          list: "/jeecg-engineering/engineering/constructionDetail/list",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          companyList:"/jeecg-engineering/engineering/constructionCompany/list"
        },
        companyList: []
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        return {
          companyId: [{ required: true, message: this.$t('请选择施工公司') },],
          isAcceptance: [{ required: true, message: this.$t('请选择是否需要验收') },],
        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,type) {
        // this.model = Object.assign({}, record);
        getAction(this.url.companyList).then(res=>{
          if(res.success){
            this.companyList = res.result.records;
          }
        });
        getAction(this.url.list,{installationId:record.id}).then(res=>{
          if(res.success){
            this.model = res.result.records[0] || {};
            this.model.installationId = record.id;
          }
        });
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = ''
            if(this.model.id){
              httpurl = this.url.edit
            }else{
              httpurl = this.url.add
            }
            postAction(httpurl,that.model).then(res=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            });
          }
         
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
</style>